// Browser & app detection utilities — extracted from legacy-utils.ts

import { hasValue } from './validation';
import { getCurrentCompanyId } from './auth';
import Bowser from 'bowser';

// Parse user-agent once and cache the result
const parsed = Bowser.getParser(window.navigator.userAgent);
const browserResult = parsed.getResult();

/** Compatibility layer matching the old bowser v1 property shape */
export const bowserInfo = {
  name: browserResult.browser.name ?? '',
  version: browserResult.browser.version ?? '',
  osname: browserResult.os.name ?? '',
  osversion: browserResult.os.version ?? '',
  blink: browserResult.engine.name === 'Blink',
  webkit: browserResult.engine.name === 'WebKit',
  msedge: browserResult.browser.name === 'Microsoft Edge',
  android: browserResult.os.name === 'Android',
};

import { isUWPApp, isIOSApp, isAndroidApp } from '@/utils/window-globals';

export function isSupportedBrowser(): boolean {
  if (bowserInfo.blink || bowserInfo.webkit || bowserInfo.msedge || isUWPApp || isIOSApp || bowserInfo.android) {
    return true;
  }
  return false;
}

export function isAndroid(): boolean {
  return /Android/.test(navigator.appVersion);
}

export function isIOSAppFromUserAgent(): boolean {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const safari = /safari/.test(userAgent);
  const ios = /iphone|ipod|ipad/.test(userAgent);
  if (ios && !safari) {
    return true;
  }
  return false;
}

export function isAtLeastVersionNumber(minAppMajorVersion: number, minAppMinorVersion: number, minAppBuildVersion: number = 0): boolean {
  // Read from window at call time — the native app reports its version asynchronously
  // (appVersionCallback), well after this module has loaded.
  const appMajorVersion = (window as any).appMajorVersion;
  const appMinorVersion = (window as any).appMinorVersion;
  const appBuildVersion = (window as any).appBuildVersion;
  const currentAppMajorVersion = hasValue(appMajorVersion) ? appMajorVersion : 0;
  const currentAppMinorVersion = hasValue(appMinorVersion) ? appMinorVersion : 0;
  const currentAppBuildVersion = hasValue(appBuildVersion) ? appBuildVersion : 0;

  if (currentAppMajorVersion > minAppMajorVersion) {
    return true;
  }
  if ((currentAppMajorVersion === minAppMajorVersion) && (currentAppMinorVersion > minAppMinorVersion)) {
    return true;
  }
  if ((currentAppMajorVersion === minAppMajorVersion) && (currentAppMinorVersion === minAppMinorVersion) && (currentAppBuildVersion >= minAppBuildVersion)) {
    return true;
  }

  return false;
}

export function showUpdateOverlay(): void {
  const overlay = document.getElementById('orna-update-overlay');
  if (overlay) overlay.style.display = 'flex';
}

export function removeUpdateOverlay(): void {
  const overlay = document.getElementById('orna-update-overlay');
  if (overlay) overlay.style.display = 'none';
  sessionStorage.removeItem('_ornaUpdating');
}

export function reloadPageSkipBrowserCache(): void {
  showUpdateOverlay();
  sessionStorage.setItem('_ornaUpdating', '1');
  (window as any).api.setAPIEnabled(false);
  window.location.replace(window.location.href);
}

export function isBetaTesting(): boolean {
  const companyId = getCurrentCompanyId();
  const betaCompanyIds: number[] = [];
  return betaCompanyIds.includes(companyId);
}
